module.exports =
  view: '/email/view/:jobId'
  render: '/email/render'
  unsubscribe: '/email/unsubscribe/:jobId'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/email.coffee